import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal"; 
import { Context } from "../contexts/AppContext";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../lib/utils"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
function DownloadVideoModal() {
 
 const { value } = useContext(Context);

 const [appState, setAppState] = value; 
  const [modalOpen, setModalOpen] = useState(appState.modalData);
 useEffect(() => {
   setModalOpen(appState.modalData); // modalOpen को अपडेट करें
 }, [appState.modalData]);


 console.log("app state xxx",appState?.videoArr)
  
 
  
  const [folderName, setFolderName] = useState("");

  Modal.setAppElement("#root");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "450px",
      height: "auto",
      width: "100%",
      overflow: "hidden",
      border:"1px solid #854d0e",
      backgroundColor:'lightgray',
      borderRadius:"10px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };

     const handleDownload = (url, filename) => {
  fetch(url, { mode: 'cors' }) // 'cors' if the file is hosted externally
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename || 'video.mp4';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(err => console.error("Download failed:", err));
};
  const closeModal = () => {
    console.log("CLOSE MODAL11111")
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 

 

  }

 
 
  return (
    <Modal
      isOpen={modalOpen.isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="New Folder Modal"
    >
      
  
{appState?.videoArr.map((item, index) => (
  <div key={index} className="flex justify-between items-center">
    <div>{item.title}</div>
    <button
      onClick={() => handleDownload(item.videoUrl, `${item.title}.mp4`)}
      className="mt-4 bg-yellow-800 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded flex gap-2 items-center whitespace-nowrap"
    >
      Download <FontAwesomeIcon icon={faCloudArrowDown} />
    </button>
  </div>
))}



  
    </Modal>
  );
}

export default DownloadVideoModal;
